export enum ApplicationCreationSources {
	HSLDAO = 1,
	BankDAO = 2,
	BankDAO2in1 = 10
}
